import React from 'react';
import { Link } from 'react-router-dom';

import SystemCopyright from '../../UI/SystemCopyright/SystemCopyright';

const notFoundErrorPage = ({ location }) => {

    document.body.className = 'page-error page-error-404 layout-full';

    return (
        <div className="page vertical-align text-center" data-animsition-in="fade-in" data-animsition-out="fade-out">
            <div className="page-content vertical-align-middle">
                <header>
                    <h1 className="animation-slide-top">404</h1>
                    <p>Page Not Found!</p>
                </header>
                <p className="error-advise">{`${location.pathname.toUpperCase()} DOES NOT EXIST`}</p>
                <Link to="/" className="btn btn-primary btn-round">GO HOME</Link>
                <SystemCopyright error404 />
            </div>
        </div>
    );
};

export default notFoundErrorPage;